/**
 * Converts markdown formatted text to clean, readable plain text
 * while preserving paragraph spacing and bullet lists.
 * @param {string} markdown - The markdown formatted text
 * @returns {string} - Clean, readable plain text with structure
 */
export const markdownToText = (markdown) => {
  if (!markdown) return '';

  let text = markdown;

  // Remove bold, italics, inline code markers, and backticks
  text = text.replace(/\*\*([^*]+)\*\*/g, '$1');
  text = text.replace(/\*([^*]+)\*/g, '$1');
  text = text.replace(/_([^_]+)_/g, '$1');
  text = text.replace(/`([^`]+)`/g, '$1');

  // Clean up blockquotes
  text = text.replace(/>\s*"?([^"]+)"?/g, '$1');

  // Replace markdown tables with plain text
  text = text.replace(/\|/g, ' ');
  text = text.replace(/-{3,}/g, '');

  // Remove <EOS> and HTML tags
  text = text.replace(/<EOS>/gi, '');
  text = text.replace(/<[^>]*>/g, '');

  // Normalize bullet points
  text = text.replace(/^\s*-\s+/gm, '- ');

  // Fix multiple newlines (but preserve paragraph spacing)
  text = text.replace(/\n{3,}/g, '\n\n');
  text = text.replace(/\s+\n/g, '\n');
  text = text.replace(/\n{2,}/g, '\n\n');

  // Clean excessive spaces
  text = text.replace(/\s{2,}/g, ' ');

  // Trim leading/trailing spaces
  text = text.trim();

  return text;
};

export default markdownToText;
